module.exports = __webpack_public_path__ + "img/phone-expense.f01642b3.webp";